import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Xmetadata } from '@utx/utx-access-client';

export interface TopUpModalProps {
  onLayout: (event: any) => void;
}

export enum TopUpStackRoutes {
  Main = 'main',
  Confirm = 'confirm',
  Placed = 'placed'
}

export type TopUpStackParamList = {
  [TopUpStackRoutes.Main]: TopUpModalProps & {
    record?: any;
    onData: (data: any) => void;
    func?: (
      accountId: string,
      amount: number,
      currency: string,
      xmetadata: Xmetadata,
      onSuccess?: (data: any) => void,
      onError?: (error: any) => void
    ) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
  };
  [TopUpStackRoutes.Confirm]: TopUpModalProps & {
    record?: any;
    data: any;
    func?: (
      accountId: string,
      amount: number,
      currency: string,
      xmetadata: Xmetadata,
      onSuccess?: (data: any) => void,
      onError?: (error: any) => void
    ) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
  };
  [TopUpStackRoutes.Placed]: TopUpModalProps & {
    record?: any;
    data?: any;
    returnData?: any;
    refresh?: () => void;
  };
};

export type TopUpStackScreenProps<Screen extends keyof TopUpStackParamList> = NativeStackScreenProps<TopUpStackParamList, Screen>;
